module.exports = __webpack_public_path__ + "static/media/points-icon.4198afea.svg";